/**
 * ============================================================================
 * KbAclDialog — Modal premium de gestão de ACL da Knowledge Base.
 *
 * Wrapper que apresenta o KbAclManager dentro de um Dialog "grande"
 * (padrão anotações do chat: max-w-5xl × 85dvh), com breadcrumb do escopo
 * e footer com contador. Utilizado em space, coleção, página e editor.
 *
 * CHANGELOG:
 *   RELEASE: 2026-07-09 v2.0.0 - Redesign premium (sidebar + tabela),
 *            paleta Slate & Steel via tokens semânticos, tipografia
 *            Sora + Manrope, header contextual com breadcrumb do escopo.
 *   RELEASE: 2026-07-08 v1.0.0 - Versão inicial (Fase C).
 * ============================================================================
 */
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { KbAclManager } from "@/components/kb/KbAclManager";
import type { KbAclScope } from "@/hooks/kb/useKbAcl";

interface Props {
  open: boolean;
  onOpenChange: (o: boolean) => void;
  scope: KbAclScope;
  scopeId: string;
  /** Nome do escopo exibido no breadcrumb (ex.: "Manutenções"). */
  title?: string;
}

const SCOPE_LABEL: Record<KbAclScope, string> = {
  page: "Página",
  collection: "Coleção",
  space: "Space",
};

export function KbAclDialog({ open, onOpenChange, scope, scopeId, title }: Props) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      {/**
       * Modal grande (padrão anotações). Removemos padding interno padrão
       * do DialogContent para o KbAclManager desenhar sua própria estrutura
       * (header + sidebar + main + footer) ocupando 100% da altura.
       */}
      <DialogContent
        className="max-w-5xl w-[95vw] h-[85dvh] p-0 gap-0 overflow-hidden flex flex-col font-body"
      >
        <KbAclManager
          scope={scope}
          scopeId={scopeId}
          scopeLabel={title}
          scopeTypeLabel={SCOPE_LABEL[scope]}
        />
      </DialogContent>
    </Dialog>
  );
}
